var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { PureComponent } from 'react';
import { connect } from 'react-redux'; // import PropTypes from 'prop-types';

import { default as Avatar } from 'antd/lib/avatar';

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

var ProfileMiniComponent = function (_super) {
  __extends(ProfileMiniComponent, _super);

  function ProfileMiniComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ProfileMiniComponent.prototype.render = function () {
    var _a = this.props,
        avatarProps = _a.avatar,
        user = _a.user,
        className = _a.className,
        style = _a.style;
    var avatar = user.avatar,
        name = user.name;

    if (avatar) {
      avatarProps.src = avatar;
    }

    return React.createElement("div", {
      className: "profile-mini " + className,
      style: style
    }, React.createElement(Avatar, __assign({}, avatarProps)), name);
  }; // static propTypes = {
  //     ...basicPropTypes,
  //     // 用户信息
  //     user: PropTypes.object,
  //     // 用户头像配置
  //     avatar: PropTypes.shape({
  //         className: PropTypes.string,
  //         style: PropTypes.object,
  //         icon: PropTypes.string,
  //         shape: PropTypes.oneOf(['circle', 'square']),
  //         size: PropTypes.oneOf(['large', 'small', 'default']),
  //         src: PropTypes.string,
  //     }),
  // };


  ProfileMiniComponent.defaultProps = {
    avatar: {
      style: {
        backgroundColor: '#91d5ff'
      },
      size: 'small',
      icon: 'user'
    }
  };
  return ProfileMiniComponent;
}(PureComponent);

export var ProfileMini = connect(mapStateToProps)(ProfileMiniComponent);